import Grid from "@material-ui/core/Grid";
import React, { Component } from "react";
import { Prompt } from "react-router";
import { Link } from "react-router-dom";
import TabsConstants from "../../../constants";
import Button from "../../FormElement/Button";
import Dropdown from "../../FormElement/Dropdown";
import InputFiled from "../../FormElement/InputFiled";


const signInSectionStyle = {
  display: "flex",
  alignItems: "baseline",
  justifyContent: "space-between"
};

class CounterpartyForm extends Component {
  state = {};
  render() {
    const {
      counterPartyInfo,
      createCounterparty,
      buttonLabel,
      formLabel,
      isValid,
      handleChange,
      handleError,
      edited
    } = this.props;
    console.log('props',this.props)
    console.log('counterpartyinfo',counterPartyInfo.typeId)
    console.log('tabconstnt',TabsConstants.partyType)
    console.log('handlechange',handleChange)
    return (
      <div className="">
        <Prompt when={edited} message="Changes you made may not be saved." />
        <div className="textRequired">* Required Cells</div>
        <div className="innermainform">
          <p className="loginHeader">{formLabel}</p>
          <Grid container spacing={16}>
            <Grid item xs={12}>
              <Dropdown
                value={counterPartyInfo.typeId}
                label="Type"
                required
                type="text"
                options={TabsConstants.partyType}
                name="typeId"
                validations={["required"]}
                handleChange={handleChange}
                handleError={handleError}
              />
            </Grid>
            <Grid item xs={12}>
              <InputFiled
                value={counterPartyInfo.name}
                label="Name"
                type="text"
                required
                name="name"
                validations={["required", "maxSize"]}
                handleChange={handleChange}
                handleError={handleError}
              />
            </Grid>
            <Grid item xs={12}>
              <InputFiled
                value={counterPartyInfo.phoneNumber}
                label="Contact Phone Number"
                type="text"
                required
                name="phoneNumber"
                validations={["onlyNumber", "required"]}
                handleChange={handleChange}
                handleError={handleError}
              />
            </Grid>
          </Grid>
          <div className="signInSection" style={signInSectionStyle}>
            <Link to="/farmsetup/counterparties" style={{ color: "blue" }}>
              Cancel
            </Link>
            <Button
              name={buttonLabel}
              disabled={isValid}
              onclick={createCounterparty}
              styleClass="signIn"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default CounterpartyForm;



// WEBPACK FOOTER //
// ./src/components/private/Counterparties/CounterpartyForm.js